module.exports = __webpack_public_path__ + "static/img/silhouette-3.svg-inverse.5b7e7d7.svg";